export default {"src":"/polygon/_next/static/media/funds-mobile.cef1c7a9.svg","height":17,"width":17};